var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"licitacije"},[_c('ChoiceBar',{attrs:{"icons":_vm.icons,"iconColor_selected":_vm.iconColor_selected,"changePage":_vm.changePage}}),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }